import { Dispatch } from "redux";
import {
    UserAuthAction,
    changeisAuthenticatedAction,
    inputPasswordAction,
    inputUsernameAction,
    loginFail,
    loginSuccess,
} from "./action";
import { NavigateFunction } from "react-router-dom";
import { axiosGet } from "../../util/axios";

export function inputUsernameThunk(username: string) {
    return (dispatch: Dispatch<UserAuthAction>) => {
        dispatch(inputUsernameAction(username));
    };
}

export function inputPasswordThunk(password: string) {
    return (dispatch: Dispatch<UserAuthAction>) => {
        dispatch(inputPasswordAction(password));
    };
}

export function changeisAuthenticatedThunk(isAuthenticated: boolean) {
    return (dispatch: Dispatch<UserAuthAction>) => {
        dispatch(changeisAuthenticatedAction(isAuthenticated));
    };
}

export function restoreCmsLogin(navigate: NavigateFunction) {
    return async (dispatch: Dispatch) => {
        const token = localStorage.getItem("loginToken");
        if (!token) {
            dispatch(loginFail());
            return;
        }

        // const result = await axiosAPIWithJson.get('/api/auth/userInfo')

        const result = await axiosGet("/api/auth/userInfo");

        if (result.data.success === false) {
            dispatch(loginFail());
        } else {
            dispatch(loginSuccess(token));
            navigate("/cms");

            return;
        }
    };
}
